class @App.Clubs.ClubsIndexView
  constructor: ->
    @bindElements()

  bindElements: ->
    loadSlick()
    BetterModals.showModal($('#modalRenewNotice')) if $('#modalRenewNotice').length

  loadSlick = ->
    $(document).ready ->
      $('.find-passion-carousel').slick {
        dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        arrows: false
      }

      return

$(document).on 'turbo:load', ->
  new App.Clubs.ClubsIndexView() if $('.clubsIndexView').length
